// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__3FUU9","slot":"Timeline_slot__y0YNi","unavailable":"Timeline_unavailable__2DwYC","time":"Timeline_time__5GclW"};